import { IState } from '../reducers'
import { FeedFilterState } from '../reducers/feed-filter.reducer'

export const getFeedFilter = (state: IState): FeedFilterState => state.feedFilter
